import gql from "graphql-tag";
import {
  ProductOverview,
  ProductOverview_products,
  ProductOverview_products_productGroup
} from "@/models/queries/types/ProductOverview";

export const QUERY_PRODUCT_OVERVIEW = gql`
  query ProductOverview {
    products {
      id
      description
      articleNumber
      customer
      screwType
      head
      screwDiameter
      screwLength
      recessType
      surfaceColor
      threadType
      productGroup {
        id
        name
      }
      templates {
        id
        name
      }
    }
  }
`;

interface DiameterLengthNumber {
  screwDiameter: number | null;
  screwLength: number | null;
}

export type ProductOverviewQueryResult = ProductOverview;
export type ProductInOverview = Omit<
  ProductOverview_products,
  "screwDiameter" | "screwLength"
> &
  DiameterLengthNumber; // diameter and length have to be numbers later, so we modify the type so that diameter and length must be numbers (or null)

export type ProductGroupInOverview = ProductOverview_products_productGroup;

export interface GroupedByProductGroup {
  productGroup: ProductGroupInOverview;
  products: ProductInOverview[];
}
